function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.593 8.27c0-1.609-.844-3.144-2.652-3.144-1.808 0-2.651 1.535-2.651 3.143 0 1.609.843 3.153 2.651 3.153 1.808 0 2.652-1.544 2.652-3.153zM8 12.106L3.055 15 4.32 9.47 0 5.73l5.725-.524L8 0l2.274 5.206L16 5.73l-4.32 3.74L12.945 15 8 12.107zm-.059-2.083c-.741 0-1.038-.685-1.038-1.764 0-1.078.297-1.754 1.038-1.754.742 0 1.039.676 1.039 1.754 0 1.079-.297 1.764-1.039 1.764z",
  fill: "currentColor"
});
function Svg0Stars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default Svg0Stars;